import { useState, useEffect, useMemo, useLayoutEffect } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useGlobalVariable } from '../../context/GlobalVariableProvider';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';

const OthersTbl = ({
    //accounts = []
    inputs={},
    requestOnRender=false,
    type=null
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
  
    // useEffect(() => {
    //     if(requestOnRender == true){
    //         //alert("requestOnRender")
    //         handleFilter(filterParams)
    //     }
        
    // }, [requestOnRender]);



  
    useEffect(() => {
        handleFilter(filterParams)

    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,1,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);
    }



    const requestTableData = async (accounts:string[],cPage=1,inputs:any={}) =>{
        if(accounts.length <1) {
            setTableData([])
            //return 
        }
       
       // if(!orderNo)return;
        setLoading(true)
        let result = await api.getMultiFinancialList(accounts, inputs,cPage);
        setLoading(false)
        if(result.financials){
            setTableData(result.financials)
        }else{
            setTableData([])
        }

     
        
        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

    
        // console.log("getTradeHistoryLogs",result)
    }

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'fr_recorddate',
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },
          
            },
            {
                Header: 'Reference',
                accessor: 'fr_referenceno',
  
            },
            {
                Header: 'Due Date',
                accessor: 'fr_duedate',
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },

            },
            {
                Header: 'Description',
                accessor: 'fr_description',
  
            },
            {
                Header: 'Remark',
                accessor: 'fr_remark',
  
            },
            {
                Header: 'O/S Amount(MYR)',
                accessor: 'fr_os_value_baseccy',
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 2)}
                        </div>
                    );
                }
            },
            {
                Header: 'O/S Interest(MYR)',
                accessor: 'fr_os_interest_baseccy',
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 2)}
                        </div>
                    );
                }
            }

       
        ],
        []
    );


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: '#B0C5F0',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                pageSize={10}
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(accounts, cPage,inputs);
                }}
                hasPagination

            />
        </>
    );
};

export default OthersTbl;
